import React,{useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import AppBarStudent from '../form/AppBarStudent';
import { useAuth } from '../service/AuthContext';
import HomeworkTable from './HomeworkTable';
import InfoBox from './InfoBox';
import PhotoBox from './PhotoBox';
import { CopyRight } from '../common/util';
import { useGlobalContext } from '../context/GlobalContext';

const defaultTheme = createTheme();

export default function DashboardStudent() {
  const [open, setOpen] = useState(false);
  const { userInfo } = useAuth();
  const { setSelectedUser, setTotalStars } = useGlobalContext();

  useEffect(()=>{
    setSelectedUser(userInfo);
    setTotalStars(userInfo?.totalStars);
  }, [setSelectedUser, setTotalStars, userInfo]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBarStudent open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8} lg={9}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 240,
                  }}
                >
                  <InfoBox />
                </Paper>
              </Grid>
              <Grid item xs={12} md={4} lg={3}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 240,
                  }}
                >
                  <PhotoBox selectedUser={userInfo}/>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <HomeworkTable />
                </Paper>
              </Grid>
            </Grid>
            {CopyRight()}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}